import React, { Fragment, useState, useEffect } from 'react';
import {
  ModalBody,
  ModalFooter,
  Modal,
  ModalHeader,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Spinner,
  Row,
} from 'reactstrap';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { useDropzone } from 'react-dropzone';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Users_By_Id,
  gAPI_Twilio_Templates,
  gAPI_Twilio_Template_Content,
  Upload_Email_Attachment,
} from '../../../../../constants/APIs';
import moment from 'moment';
import { NotificationManager } from '../../../../../components/common/react-notifications';
const TWILIOCHANNEL_URL = process.env.REACT_APP_CHAT_API + '/twiliochannels';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;       
      }

      .ql-container{
        border: 1px solid #ccc !important; 
        border-radius: 0px!important;   
        background:white;      
      }
      
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const NewWhatsAppConnection = ({
  visible,
  toggle,
  whatsAppIntegration,
  propertyId,
}) => {
  const [attachementList, setAttachmentList] = useState([]);
  const fileObj = [];
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      // acceptedFiles.map((file) => {
      //   if (!file.name.includes('exe')) {
      //     fileObj.push({
      //       img: Object.assign(file, {
      //         preview: URL.createObjectURL(file),
      //       }),
      //     });
      //   }
      // });
      // setAttachmentList([...attachementList, ...fileObj]);
    },
  });
  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailData, setEmailData] = useState({
    from: whatsAppIntegration?.channelDetails?.forwardingEmail,
    templateId: '',
    to: '',
    text: '',
    attachments: [],
  });

  const handleChange = (e) =>
    setEmailData({ ...emailData, [e.target.name]: e.target.value });

  const handleMessage = (source, e) => {
    if (source === 'user') setEmailData({ ...emailData, text: e });
  };

  const handleRemove = (index) => {
    let lst = [...attachementList];
    lst = lst.filter((f, i) => i !== index);
    setAttachmentList(lst);
    // handleFiles(lst);
  };
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
    }).then((res) => {
      setTemplateList(res.data);
    });
  }, [propertyId]);

  const handleTemplate = (e) => {
    let templateData = templateList.filter(
      (f) => f.templateId === e.target.value
    );
    if (templateData.length > 0) {
      setLoading(true);
      AxiosPublicAPI({
        method: 'post',
        url:
          process.env.REACT_APP_CHAT_API +
          '/twilio-template-content' +
          '/' +
          templateData[0].templateId +
          '?item=' +
          templateData[0].templateType,
        data: {
          accountSID: whatsAppIntegration?.channelDetails?.accountSID,
          authToken: whatsAppIntegration?.channelDetails?.authToken,
        },
      }).then((res) => {
        console.log(res.data);
        let text = '';
        if (res.data?.title && res.data?.title != null) {
          text += res.data?.title + '\n';
        }
        if (res.data?.subTitle && res.data?.subTitle != null) {
          text += res.data?.subTitle + '\n';
        }
        if (res.data?.body && res.data?.body != null) {
          text += res.data?.body + '\n';
        }
        let placeholders = [];
        if (text.length > 0) {
          var regex = new RegExp(/{{(.*?)}}/, 'g');
          const regexNEw = /{{(.*?)}}/;
          var match = regexNEw.exec(text).groups;
          console.log(match, 164);
          Array.from(text.matchAll(regex), (m) => m[0]).map((m) =>
            placeholders.push({ key: m, value: '' })
          );
        }
        setEmailData({
          ...emailData,
          text: text,
          templateId: e.target.value,
          placeholders: placeholders,
        });
        setLoading(false);
      });
    }
  };

  const handlePlaceHolders = (value, index) => {
    let placeholders = [...emailData.placeholders];
    placeholders[index].value = value;
    console.log(placeholders);
    setEmailData({ ...emailData, placeholders: placeholders });
    console.log(whatsAppIntegration);
  };

  const sendMessage = async (draft = false) => {
    let templateData = {};
    let placeholders = [...emailData.placeholders];
    if (placeholders.filter((f) => f.value === '').length === 0) {
      placeholders.map(
        (m) =>
          (templateData[m.key.replaceAll('{', '').replaceAll('}', '')] =
            m.value)
      );
      let message = emailData.text;
      placeholders.map((m) => (message = message.replace(m.key, m.value)));
      // let attachments = [];
      // if (attachementList !== undefined && attachementList.length > 0) {
      //   const result = await handleAttachmentUpload('');
      //   if (result?.data && result.data.length > 0) {
      //     result.data.map((m) => {
      //       attachments.push({
      //         shortName: m.shortName,
      //         fileName: m.fileName,
      //         contentType: m.contentType,
      //       });
      //     });
      //   }
      // }
      // let email = '';
      // if (whatsAppIntegration !== undefined) {
      //   email = whatsAppIntegration?.channelDetails?.forwardingEmail;
      // }
      let requestBody = {
        groupId: getGroupID(),
        integrationId: whatsAppIntegration?.id,
        UsingLocalStorage: true,
        welcomeMessage: 'https://whatsapp.com',
        language: 'en-US',
        message: message,
        fromNumber: `whatsapp:${whatsAppIntegration?.channelDetails?.phoneNumber}`,
        propertyId: propertyId,
        toNumber: `${emailData.to}`,
        templateId: emailData?.templateId,
        templateData: templateData,
        accountSID: whatsAppIntegration?.channelDetails?.accountSID,
        authToken: whatsAppIntegration?.channelDetails?.authToken,
        messageService: whatsAppIntegration?.channelDetails?.messageService,
      };
      let url = `${process.env.REACT_APP_CHAT_API}/proactiveMessage`;
      AxiosPublicAPI({
        method: 'post',
        url: url,
        data: requestBody,
      }).then((res) => {
        toggle();
      });
    } else {
      NotificationManager.error(
        '',
        'Please complete all placeholders correctly.',
        3000,
        null,
        null,
        'error'
      );
    }
  };
  const handleAttachmentUpload = async (sessionId) => {
    const data = new FormData();
    attachementList.forEach((file) => {
      data.append('files', file.img);
    });
    data.append('sessionId', sessionId);
    data.append('creator', 'dashboard');
    return await AxiosAPI({
      method: 'post',
      url: `${Upload_Email_Attachment}`,
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Whatsapp</ModalHeader>
        <ModalBody>
          <style>{styles}</style>
          <Row className="">
            <Colxx md="12" className="mb-2">
              <h5>Template</h5>
            </Colxx>
            <Colxx md="12" className="mb-2">
              <Input
                type="select"
                //value={}
                name="Template"
                onChange={handleTemplate}
              >
                <option value="">Please Select</option>
                {templateList &&
                  templateList.length > 0 &&
                  templateList.map((m) => (
                    <option value={m?.templateId}>{m?.name}</option>
                  ))}
              </Input>
            </Colxx>
            {emailData?.templateId && emailData?.templateId !== '' ? (
              <Fragment>
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" className="mb-1" />
                  </div>
                ) : (
                  <Fragment>
                    <Colxx
                      md="12"
                      className="mb-2"
                      style={{ marginTop: '1.95rem' }}
                    >
                      <h5>To</h5>
                    </Colxx>
                    <Colxx md="12" className="mb-2">
                      <Input
                        type="text"
                        name="to"
                        id="to"
                        value={emailData?.to}
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx
                      md="12"
                      className="mb-2"
                      style={{ marginTop: '1.95rem' }}
                    >
                      <h5>Message</h5>
                    </Colxx>
                    <Colxx md="12" className="mb-2">
                      <Input
                        type="textarea"
                        value={emailData?.text}
                        name="conditions"
                        disabled={true}
                        // onChange={handleChangeConditionsArr}
                      />
                    </Colxx>
                    <Colxx
                      md="12"
                      className="mb-2"
                      style={{ marginTop: '1.95rem' }}
                    >
                      <h5>PlaceHolders</h5>
                    </Colxx>
                    {emailData?.placeholders &&
                      emailData?.placeholders.map((e, index) => (
                        <Colxx md="6" className="mb-2">
                          <InputGroup>
                            <InputGroupAddon>
                              <InputGroupText>{e?.key}</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              type="text"
                              name={e?.key}
                              id={e?.key}
                              value={e?.value}
                              onChange={(v) =>
                                handlePlaceHolders(v.target.value, index)
                              }
                            />
                          </InputGroup>
                        </Colxx>
                      ))}
                    {/* <Colxx
                      md="12"
                      className="mb-2"
                      style={{ marginTop: '1.95rem' }}
                    >
                      <h5>Attachments</h5>
                    </Colxx>
                    <Colxx md="12" className="mb-2">
                      <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <div class="dz-default dz-message">
                          <span>Coming Soon</span>
                        </div>
                      </div>
                    </Colxx> */}
                    <Colxx md="12" className="mb-2">
                      {attachementList.map((file, index) => (
                        <Row className="mx-0">
                          <Colxx
                            md="10"
                            style={{ border: '1px solid', padding: '5px 10px' }}
                          >
                            <div key={index}>
                              <div className="row mx-0">
                                <span data-dz-name>{file.img.name}</span>
                                <div
                                  className="text-primary text-extra-small"
                                  data-dz-size
                                >
                                  {file.img.size}
                                </div>
                              </div>
                            </div>
                          </Colxx>
                          <Colxx md="2">
                            <Button
                              color="danger"
                              outline
                              size="xs"
                              onClick={() => handleRemove(index)}
                            >
                              X
                            </Button>
                          </Colxx>
                        </Row>
                      ))}
                    </Colxx>
                  </Fragment>
                )}
              </Fragment>
            ) : null}
          </Row>
        </ModalBody>
        <ModalFooter>
          {emailData?.templateId && emailData?.templateId !== '' ? (
            <Button color="primary" size="xs" outline onClick={sendMessage}>
              Send
            </Button>
          ) : null}
          <Button color="secondary" size="xs" outline onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default NewWhatsAppConnection;
